import * as React from "react"
import { Col, Container, Hidden, Row, Visible } from "react-grid-system"
import { HorizontalSpacer, Spacer } from "../../atoms/spacers"
import H4 from "../../atoms/typography/H4"
import { theme } from "../../theme"
import styled from "styled-components"
import H1 from "../../atoms/typography/H1"
import SecondaryButton from "../../atoms/buttons/SecondaryButton"
import H3 from "../../atoms/typography/H3"
import { ActiveItemBar } from "../../atoms/ActiveItemColoredBar"
import H2 from "../../atoms/typography/H2"
import Body from "../../atoms/typography/Body"
import BodyLarge from "../../atoms/typography/BodyLarge"
//@ts-ignore
import AbcNewsLogo from "../../atoms/icons/images/abcnewslogo.svg"
//@ts-ignore
import ItvLogo from "../../atoms/icons/images/itvlogo.svg"
//@ts-ignore
import CbsLogo from "../../atoms/icons/images/cbslogo.svg"
//@ts-ignore
import FnLogo from "../../atoms/icons/images/fnlogo.svg"
import { ContactPhoneIcon } from "../../atoms/icons/ContactPhoneIcon"
import { ArrowRight } from "../../atoms/icons/ArrowRight"
import { Link } from "react-router-dom"
import NavigationTextButton from "../../atoms/buttons/NavigationTextButton"
import { MediaQuery } from "../../../utils/design-helpers"
import SmallColorfulButton from "../../atoms/buttons/SmallColorfulButton"
import LoadingSpinner from "../../atoms/LoadingSpinner"
import Markdown from "react-markdown"
import { DownloadProductSheetButton } from "../../molecules/store/DownloadProductSheet"
import { RequestDemoButton } from "../../molecules/store/RequestDemo"
import { useInView, useScrollToRef } from "../../../utils/helpers"
import { captureExceptionWithContext } from "../../../utils/sentry"
import { useProductPageCollection } from "../../../hooks/products/useProductPageCollection"
import Subtitle from "../../atoms/typography/Subtitle"
import { TerminalColorPicker } from "../../molecules/store/ProductPages/TerminalColorPicker"
import UspCarouselTwo from "../../contentful/UspCarouselTwo"
import { useUspCarousel } from "../../../hooks/products/useUspCarousel"
import Button from "../../atoms/buttons/Button"

const ProductImage = styled.img`
  object-fit: contain;
  border-radius: 18px;
`
const ColoredTitle = styled(H1)`
  background: ${(props) => props.theme.gradients.blue};
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 700;
`

const SubtitleBold = styled(Subtitle)`
  color: ${({ theme }) => theme.colors.dark};
  font-weight: 700;
`

const GreySection = styled.div`
  width: 100%;
  background: var(--Darker-grey-gradient, linear-gradient(180deg, #585858 0%, #444 100%));
  position: relative;
  z-index: 2;
`

const FlexRowCol = styled.div`
  display: flex;
  flex-direction: column;
  padding: 44px 16px 44px 16px;
  justify-content: space-between;
  max-width: 80%;

  ${MediaQuery.XS} {
    max-width: 100%;
  }
`

const FlexRowColSmall = styled(Col)`
  display: flex;
  flex-direction: column;
  padding: 16px;
  justify-content: space-between;
  height: 322px;

  ${MediaQuery.XS} {
    height: 280px;
  }
`

const FooterImage = styled.img`
  width: 100%;
  height: 259px;
  object-fit: cover;
`

const FooterContainer = styled.div`
  position: absolute;
  top: 25%;
  left: 0;
  padding: 1rem;
  width: 100%;
`

const ContactSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  cursor: pointer;

  :hover {
    filter: opacity(0.6);
  }
`

const FixedBottomMenu = styled.div`
  width: 100%;
  padding: 0.5rem;
  background: rgba(250, 250, 250, 0.8);
  backdrop-filter: blur(3px);
  position: sticky;
  left: 0;
  top: 75px;
  z-index: 4;
  box-shadow: 0px 1px 6px 0px rgba(119, 119, 119, 0.25);

  ${MediaQuery.XS} {
    top: 55px;
  }

  ${MediaQuery.SM}, ${MediaQuery.MD} {
    top: 50px;
  }

  ${MediaQuery.LG} {
    top: 60px;
  }
`

const MenuNavigationContainer = styled.div`
  display: flex;
  justify-content: space-around;
  flex: 0.5;
  align-items: center;
`

const MapCoverageImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;

  ${MediaQuery.XS} {
    height: 162px;
  }
`

const PartnersSectionContainer = styled.div`
  position: relative;
`

const PartnersSectionSvgStyle = styled.svg`
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  min-width: 1432px; // width of the svg box
`

const PartnerSectionBackground = () => (
  <PartnersSectionSvgStyle xmlns="http://www.w3.org/2000/svg" width="1280" fill="none" viewBox="0 0 1280 509">
    <path
      fill="url(#paint0_linear_8394_15317)"
      fillOpacity="0.6"
      d="M-30 0h1414l18 474.5S1213 519 1041.5 506c-160.287-12.15-262.945-90.1-423-105-139.974-13.031-221.235-6.905-359.5 18.5C143.131 440.79-30 506-30 506z"
      style={{ mixBlendMode: "darken" }}
    ></path>
    <defs>
      <linearGradient
        id="paint0_linear_8394_15317"
        x1="50.978"
        x2="1151.32"
        y1="92"
        y2="473.845"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#81A6C8"></stop>
        <stop offset="1" stopColor="#97D1D9"></stop>
      </linearGradient>
    </defs>
  </PartnersSectionSvgStyle>
)

const PartnersContentOnTop = styled.div`
  width: 100%;

  ${MediaQuery.XS} {
    padding: 1rem;
  }
`

const ExplodedImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`

const ScaledPartners = styled.div`
  ${MediaQuery.XS} {
    transform: scale(0.5);
  }
`

const NAVBAR_OFFSET = 160

interface UspPointItemProps {
  active: boolean
  title: string
  text: string
}

const UspPointItem: React.FC<UspPointItemProps> = ({ active, title, text }) => {
  return (
    <Row style={{ padding: 8 }}>
      <Col lg={4}>
        {active ? (
          <H2 color={active ? theme.colors.dark : theme.colors.greyDisabled}>{title}</H2>
        ) : (
          <H3 color={active ? theme.colors.dark : theme.colors.greyDisabled}>{title}</H3>
        )}

        <HorizontalSpacer spacing={0.5} />
        <ActiveItemBar short color={active ? theme.gradients.blue : theme.colors.greyDisabled} />
      </Col>
      <Col lg={8}>
        {active ? (
          <BodyLarge color={active ? theme.colors.dark : theme.colors.greyDisabled}>{text}</BodyLarge>
        ) : (
          <Body color={active ? theme.colors.dark : theme.colors.greyDisabled}>{text}</Body>
        )}
      </Col>
    </Row>
  )
}

const KuProductPage: React.FC = () => {
  const { productPages, error, loading } = useProductPageCollection()
  const kuproductpage = productPages?.items?.find((x: any) => x.title === "ku")
  const uspCarousel = useUspCarousel("1UKr4tXHttcDWJ08VGK8Xi")

  if (error) {
    captureExceptionWithContext(error, "error fetching product pages from contentful")
  }

  const overviewRef = React.useRef<HTMLDivElement>(null)
  const applicationsRef = React.useRef<HTMLDivElement>(null)
  const specRef = React.useRef<HTMLDivElement>(null)
  const bottomRef = React.useRef<HTMLDivElement>(null)

  const overviewRefIsInView = useInView(overviewRef)
  const applicationsRefIsInView = useInView(applicationsRef)
  const specRefIsInView = useInView(specRef)

  const scrollToRef = useScrollToRef(NAVBAR_OFFSET)

  React.useEffect(() => {
    if (overviewRefIsInView && !applicationsRefIsInView && !specRefIsInView) {
      setActiveSection(0)
    } else if (!overviewRefIsInView && applicationsRefIsInView && !specRefIsInView) {
      setActiveSection(1)
    } else if (!overviewRefIsInView && !applicationsRefIsInView && specRefIsInView) {
      setActiveSection(2)
    }
  }, [overviewRefIsInView, applicationsRefIsInView, specRefIsInView])

  const [activeSection, setActiveSection] = React.useState(0)

  const scrollToOverview = () => {
    scrollToRef(overviewRef)
  }
  const scrollToApplications = () => {
    scrollToRef(applicationsRef)
  }
  const scrollToSpecifications = () => {
    scrollToRef(specRef)
  }

  const [activeSetupStep, setActiveSetupStep] = React.useState(0)

  React.useEffect(() => {
    document.title = "Ku Product"
    // Set up interval for changing activeSetupStep
    const intervalId = setInterval(() => {
      setActiveSetupStep((prevStep) => (prevStep + 1) % 4)
    }, 3000)

    // Clean up on component unmount
    return () => {
      clearInterval(intervalId)
    }
  }, [])

  return (
    <div style={{ position: "relative" }}>
      <FixedBottomMenu>
        <Container>
          <Row nogutter justify="between" align="center">
            <H2 color={theme.colors.dark}>Satcube Ku</H2>
            <Hidden xs sm md>
              <MenuNavigationContainer>
                <NavigationTextButton
                  title="Overview"
                  onClick={scrollToOverview}
                  active={activeSection === 0}
                  color={theme.colors.dark}
                  subMenu
                />
                <Spacer spacing={1} />
                <NavigationTextButton
                  title="Applications"
                  onClick={scrollToApplications}
                  active={activeSection === 1}
                  color={theme.colors.dark}
                  subMenu
                />
                <Spacer spacing={1} />
                <NavigationTextButton
                  title="Specifications"
                  onClick={scrollToSpecifications}
                  active={activeSection === 2}
                  color={theme.colors.dark}
                  subMenu
                />
              </MenuNavigationContainer>
            </Hidden>
            <Link to="/store/customize/ku">
              <SmallColorfulButton title="Customise and order" />
            </Link>
          </Row>
        </Container>
      </FixedBottomMenu>
      <HorizontalSpacer spacing={2} />
      <div ref={overviewRef} id="overviewSection" />
      <Container>
        <Row align="center" justify="center">
          <Col xs="content" lg={6}>
            <ProductImage
              width={528}
              src="https://images.ctfassets.net/kzqg847wz5jr/7y4j5V6dYPi97Lckot3ugL/0608e6fb91817ea08cab5419487c5832/Ku_header.webp"
            />
          </Col>
          <Col lg={6} style={{ padding: 16 }}>
            {loading && <LoadingSpinner />}
            <H4 textAlign="center">New, upgraded terminal:</H4>
            <HorizontalSpacer spacing={1} />
            <ColoredTitle textAlign="center">{kuproductpage?.promoTitleGradient}</ColoredTitle>
            <HorizontalSpacer spacing={1} />
            <SubtitleBold textAlign="center">{kuproductpage?.promoSubtitle}</SubtitleBold>
            <HorizontalSpacer spacing={1} />
            <Row align="center" justify="center" nogutter>
              <DownloadProductSheetButton productSheetType="satcube_ku" buttonType="colorBlue" />
              <Hidden xs md>
                <Visible lg>
                  <Spacer spacing={0.25} />
                </Visible>
                <Visible xl xxl xxxl>
                  <Spacer spacing={2.25} />
                </Visible>
                <RequestDemoButton productType="satcube_ku" buttonType="secondary" />
              </Hidden>
            </Row>
            <Visible xs md>
              <HorizontalSpacer spacing={2} />
              <Row justify="center">
                <RequestDemoButton productType="satcube_ku" buttonType="secondary" />
              </Row>
            </Visible>
          </Col>
        </Row>
      </Container>
      <HorizontalSpacer spacing={6} />
      <Container>
        <Visible xs sm md>
          <H1 bold textAlign="center">
            New Satcube Ku
          </H1>
          <HorizontalSpacer spacing={1} />
        </Visible>
        <Row justify="center">
          <Visible xs sm md>
            <Col>
              <Row justify="center">
                <TerminalColorPicker product="ku" />
              </Row>
            </Col>
          </Visible>
          <Col lg={6}>
            <Row justify="center">
              <Col>
                <Hidden xs sm md>
                  <H1 bold>Updated Satcube Ku</H1>
                </Hidden>
                <HorizontalSpacer spacing={1} />
                <H3>Updated terminal available in two new colors</H3>
                <HorizontalSpacer spacing={1.5} />
                <ul>
                  <li>
                    <Body>Ultra portable Wi-Fi hotspot with speeds up to 20 Mbps up and down</Body>
                  </li>
                  <li>
                    <Body>GNSS-independent - functional in GPS-denied environments</Body>
                  </li>
                  <li>
                    <Body>Upgraded security features - Dark mode and PIN lock</Body>
                  </li>
                  <li>
                    <Body>Instant connectivity - from transport case to fully deployed terminal in under a minute</Body>
                  </li>
                  <li>
                    <Body>Easily carried in backpacks at only 8 kgs</Body>
                  </li>
                  <li>
                    <Body>
                      Battery-driven and IP65-certified (IP67 optional), tested for temperatures from -35° to +60° C
                    </Body>
                  </li>
                  <li>
                    <Body>Outperforms traditional devices in size, speed, ease-of-use and design</Body>
                  </li>
                </ul>
              </Col>
            </Row>
          </Col>
          <Hidden xs sm md>
            <Col lg={4}>
              <Row justify="end">
                <TerminalColorPicker product="ku" />
              </Row>
            </Col>
          </Hidden>
        </Row>
      </Container>
      <HorizontalSpacer spacing={6} />
      <GreySection>
        <Container>
          <HorizontalSpacer spacing={8} />
          {uspCarousel.data && <UspCarouselTwo uspCarousel={uspCarousel.data} />}
          {/* <UspCarousel color={theme.gradients.blue} data={kuUspData} /> */}
          <HorizontalSpacer spacing={8} />
        </Container>
      </GreySection>

      <HorizontalSpacer spacing={8} />

      <Container>
        <Row align="center">
          <Col lg={5}>
            <ColoredTitle>{kuproductpage?.internetCoverageTitle}</ColoredTitle>
            <HorizontalSpacer spacing={1} />
            <Body>
              <Markdown>{kuproductpage?.internetCoverageText}</Markdown>
            </Body>
            <HorizontalSpacer spacing={1} />
            <Row nogutter>
              <Button
                variant="blue"
                title="Read more about our network solutions"
                link="/products/network"
                fullWidth={false}
                iconRight={<ArrowRight color="white" />}
              />
            </Row>
          </Col>
          <Col lg={7}>
            <MapCoverageImage src="https://images.ctfassets.net/kzqg847wz5jr/7ymVFoQMxqSUlg8sVFJwyW/f095fcce638a82b7921621a3ed38c570/Service_Area_-_FlexMove_Commercial_-_edited-1_2.png" />
          </Col>
        </Row>
        <HorizontalSpacer spacing={8} />
      </Container>

      <Container>
        <UspPointItem
          active={activeSetupStep === 0}
          title={kuproductpage?.uspOneTitle}
          text={kuproductpage?.uspOneText}
        />
        <HorizontalSpacer spacing={2} />
        <UspPointItem
          active={activeSetupStep === 1}
          title={kuproductpage?.uspTwoTitle}
          text={kuproductpage?.uspTwoText}
        />
        <HorizontalSpacer spacing={2} />
        <UspPointItem
          active={activeSetupStep === 2}
          title={kuproductpage?.uspThreeTitle}
          text={kuproductpage?.uspThreeText}
        />
        <HorizontalSpacer spacing={2} />
        <UspPointItem
          active={activeSetupStep === 3}
          title={kuproductpage?.uspFourTitle}
          text={kuproductpage?.uspFourText}
        />

        <HorizontalSpacer spacing={8} />
      </Container>

      <div ref={applicationsRef} id="applicationsSection" />

      <GreySection>
        <Row>
          <Col lg={6}>
            <video
              src="https://videos.ctfassets.net/kzqg847wz5jr/5KLel4iVRM8TifpBNdjQOi/cd9a979438e8d40ff8c3eb804ab75a37/f2603bdd-e07c-4834-9bae-5144e91b9ed6.webm"
              poster="https://images.ctfassets.net/kzqg847wz5jr/1uGI9D1FaUUQuQQBaSnOgD/fdd409e6412f60d000660e8126b73457/Rectangle_970.png"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                //marginBottom: -8,
              }}
              loop
              autoPlay
              muted
              playsInline
            />
          </Col>
          <Col lg={6}>
            <Container>
              <FlexRowCol>
                <ColoredTitle>{kuproductpage?.applicationsTitle}</ColoredTitle>
                <HorizontalSpacer spacing={2} />
                <div>
                  <Row nogutter justify="between">
                    <H3 color="white">Humanitarian aid organizations</H3>
                    <H3 color="white">Governments</H3>
                  </Row>
                  <HorizontalSpacer spacing={0.5} />
                  <Row nogutter justify="between">
                    <H3 color="white">Media Companies</H3>
                    <H3 color="white">First responders</H3>
                  </Row>
                </div>
                <HorizontalSpacer spacing={2} />
                <Body color="white">
                  <Markdown>{kuproductpage?.applicationsText}</Markdown>
                </Body>

                <HorizontalSpacer spacing={2} />

                <Row nogutter>
                  <Button
                    title="Read more about applications"
                    variant="blue"
                    fullWidth={false}
                    iconRight={<ArrowRight color="white" />}
                    link="/applications"
                  />
                </Row>
              </FlexRowCol>
            </Container>
          </Col>
        </Row>
      </GreySection>

      <div style={{ position: "relative" }}>
        <PartnersSectionContainer>
          <HorizontalSpacer spacing={4} />
          <PartnerSectionBackground />
        </PartnersSectionContainer>

        <PartnersContentOnTop>
          <Container>
            <H3 textAlign="center" color={theme.colors.greyDark}>
              Some of our customers:
            </H3>
            <Hidden xs md>
              <Row justify="around">
                <AbcNewsLogo />
                <ItvLogo />
                <CbsLogo />
                <FnLogo />
              </Row>
            </Hidden>
            <Visible xs md>
              <Row justify="center" align="center">
                <Col xs={6} md={6}>
                  <ScaledPartners>
                    <AbcNewsLogo />
                  </ScaledPartners>
                </Col>
                <Col xs={6} md={6}>
                  <ScaledPartners>
                    <ItvLogo />
                  </ScaledPartners>
                </Col>
                <Col xs={6} md={6}>
                  <ScaledPartners>
                    <CbsLogo />
                  </ScaledPartners>
                </Col>
                <Col xs={6} md={6}>
                  <ScaledPartners>
                    <FnLogo />
                  </ScaledPartners>
                </Col>
              </Row>
            </Visible>
            <HorizontalSpacer spacing={1} />
            <Row justify="center">
              <div style={{ maxWidth: 680 }}>
                <BodyLarge color={theme.colors.dark} textAlign="center">
                  <Markdown>{kuproductpage?.quote}</Markdown>
                </BodyLarge>
              </div>
            </Row>
          </Container>
        </PartnersContentOnTop>
      </div>

      <Container>
        <Hidden xs sm>
          <HorizontalSpacer spacing={15} />
        </Hidden>
        <div ref={specRef} id="specsSection" />
        <Row align="center">
          <Col lg={1} />
          <Col lg={5}>
            <ExplodedImage src="https://images.ctfassets.net/kzqg847wz5jr/2PncDzPAclylWoK3RdqYU9/2fca238e02fb3d9454525449865ad943/Satcube_ku-exploded2-fafafa_2.png" />
          </Col>
          <Col lg={5}>
            <ColoredTitle>Handmade hightech</ColoredTitle>
            <H2>Technical specifications</H2>
          </Col>
        </Row>
        <HorizontalSpacer spacing={4} />
        <Row>
          <FlexRowColSmall lg={4}>
            <div>
              <H3>Dimensions</H3>
              <HorizontalSpacer spacing={0.5} />
              <Body>470 x 300 x 55 mm</Body>
              <HorizontalSpacer spacing={0.25} />
              <Body>18,5 x 11,8 x 2,17 inch</Body>
            </div>
            <div>
              <H3>Environmental rating</H3>
              <HorizontalSpacer spacing={0.5} />
              <Body>IP65/IP67 water and dust proof </Body>
            </div>
            <div>
              <H3>Power</H3>
              <HorizontalSpacer spacing={0.5} />
              <Body>24 VDC, 130 W</Body>
              <HorizontalSpacer spacing={0.25} />
              <Body>AC/DC 100 - 240 VAC, </Body>
              <HorizontalSpacer spacing={0.25} />
              <Body>47 - 63 Hz</Body>
            </div>
          </FlexRowColSmall>
          <FlexRowColSmall lg={4}>
            <div>
              <H3>Antenna parameters</H3>
              <HorizontalSpacer spacing={0.5} />
              <Body>Tx: 13.75 - 14.50 GHz (Ku band)</Body>
              <HorizontalSpacer spacing={0.25} />
              <Body>Rx: 10.95 - 12.75 GHz (Ku band)</Body>
              <HorizontalSpacer spacing={0.25} />
              <Body>Linear polarisation</Body>
              <HorizontalSpacer spacing={0.25} />
              <Body>EIRP: 46 dBW</Body>
              <HorizontalSpacer spacing={0.25} />
              <Body>G/T: 9 db/K</Body>
            </div>
            <div>
              <H3>Approvals</H3>
              <HorizontalSpacer spacing={0.5} />
              <Body>CE [RED directive (2014/</Body>
              <HorizontalSpacer spacing={0.25} />
              <Body>53/UE), EN 301 428)] FCC</Body>
            </div>
          </FlexRowColSmall>
          <FlexRowColSmall lg={4}>
            <div>
              <H3>Satellite modem</H3>
              <HorizontalSpacer spacing={0.5} />
              <Body>iDirect IQ 200</Body>
              <HorizontalSpacer spacing={0.25} />
              <Body>Newtech MDM2510</Body>
              <HorizontalSpacer spacing={0.25} />
              <Body>UHP 210</Body>
            </div>
            <div>
              <H3>Wide temperature range</H3>
              <HorizontalSpacer spacing={0.5} />
              <Body>-35°C to 60°C / -31°F to 140°F</Body>
            </div>
            <div>
              <H3>Data rate</H3>
              <HorizontalSpacer spacing={0.5} />
              <Body>Up to 85/20Mbps via HTS</Body>
            </div>
          </FlexRowColSmall>
        </Row>
        <HorizontalSpacer spacing={6.5} />
        <Row nogutter justify="center" align="center">
          <DownloadProductSheetButton productSheetType="satcube_ku" buttonType="colorBlue" />
          <Hidden xs md>
            <Spacer spacing={3} />
            <Link to="/store#ku">
              <SecondaryButton title="Discover more products" iconRight={<ArrowRight color="white" />} />
            </Link>
          </Hidden>
        </Row>

        <Visible xs md>
          <HorizontalSpacer spacing={2} />
          <Row justify="center">
            <Link to="/store#ku">
              <SecondaryButton title="Discover more products" iconRight={<ArrowRight color="white" />} />
            </Link>
          </Row>
        </Visible>

        <HorizontalSpacer spacing={8} />
      </Container>
      <div ref={bottomRef} />

      <div style={{ position: "relative", width: "100%" }}>
        <FooterImage src="https://images.ctfassets.net/kzqg847wz5jr/1L91M1LdJ0rM8WwWJXNIhw/2e7c2ef2ada5126dfc880dcc82c49746/MicrosoftTeams-image__8_.png" />
        <FooterContainer>
          <Container>
            <Row justify="between">
              <div>
                <H1 color="white">Want to know more?</H1>
                <RequestDemoButton productType="satcube_ku" buttonType="textwhite" />
              </div>
              <Link to="/contact">
                <ContactSection>
                  <ContactPhoneIcon color="white" />
                  <Spacer spacing={1} />
                  <H3 color="white">Contact sales</H3>
                </ContactSection>
              </Link>
            </Row>
          </Container>
        </FooterContainer>
      </div>
    </div>
  )
}

export default KuProductPage
